import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-thank-you-question-modal',
  templateUrl: './thank-you-question-modal.component.html',
  styleUrls: ['./thank-you-question-modal.component.css'],
})
export class ThankYouQuestionModalComponent  implements OnInit {

  constructor(
    private modalCtrl: ModalController,
  ) { }

  
  ngOnInit() {
    setTimeout(() => {
      this.dismiss();
    }, 5000);
  }
 
   dismiss() {
     this.modalCtrl.dismiss();
   }
}
